module.exports = __webpack_public_path__ + "img/extra-finsta.ca77b1e.png";